'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.repeat = exports.collate = exports.mergeFlags = exports.DelayedEvent = exports.f = exports.a = exports.o = undefined;

var _array = require('./array');

var _object = require('./object');

var _function = require('./function');

var _collate = require('./collate');

//Random helpers
var repeat = function repeat(count, f) {
    for (var i = 0; i < count; i++) {
        f();
    }
};

exports.o = _object.o;
exports.a = _array.a;
exports.f = _function.f;
exports.DelayedEvent = _function.DelayedEvent;
exports.mergeFlags = _object.mergeFlags;
exports.collate = _collate.collate;
exports.repeat = repeat;